import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getMachinePart, updateMachinePart } from '@/apis/machinePart'
import useNotification from '@/hooks/useNotification'
import { GetMachinePartRequest } from '@/types/apis/machineParts/GetMachinePartRequest'
import { GetMachinePartResponse } from '@/types/apis/machineParts/GetMachinePartResponse'
import { UpdateMachinePartRequest } from '@/types/apis/machineParts/UpdateMachinePartRequest'
import { UpdateMachinePartResponse } from '@/types/apis/machineParts/UpdateMachinePartResponse'

export const useUpdateMachineParts = () => {
  const { t } = useTranslation()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<UpdateMachinePartResponse>()
  const update = useCallback(
    async (request: UpdateMachinePartRequest) => {
      try {
        setLoading(true)
        const res = await updateMachinePart(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.update.success') })
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.update.fail') })
      } finally {
        setLoading(false)
      }
    },
    [openNotification, t]
  )

  return {
    loading,
    updateMachinePart: update,
    response,
  }
}

export const useGetMachinePart = () => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<GetMachinePartResponse>()

  const get = useCallback(async (request: GetMachinePartRequest) => {
    try {
      setLoading(true)
      const res = await getMachinePart(request)
      setResponse(res)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    getMachinePart: get,
    response,
  }
}
